import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import Modal from "../../../modal";
import { MdAdd, MdClose } from "react-icons/md";
import { useParams } from "react-router-dom";
import { createField } from "../../../utils/databaseactions";
import { TypesValue } from "../../../contexts/types";
import { UserValue } from "../../../contexts/user";

export default function AddField({ id, table, update }) {
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [isList, setIsList] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const types = useContext(TypesValue);
  const user = useContext(UserValue);
  const { appId } = useParams();

  useEffect(() => {
    if (!open) {
      setName("");
      setType("");
      setIsList(false);
      setIsDisabled(true);
      setFnIsRunning(false);
    }
  }, [open]);

  useEffect(() => {
    if (name.length === 0 || type === "" || type.name === "none") setIsDisabled(true);
    else setIsDisabled(false);
  }, [name, type]);

  const nameIsValid = (n) => {
    const validChars = " abcdefghijklmnopqrstuvwxyz";
    for (let i = 0; i < n.length; i++) {
      if (!validChars.includes(n.charAt(i).toLowerCase())) return false;
    }
    return true;
  }

  const typeIsValid = () => {
    if (typeof type !== "object" || !type.hasOwnProperty("name")) {
      return false;
    }
    const typeNames = types.map(cur => cur.name);
    if (!typeNames.includes(type.name)) return false;
    return true;
  }

  const submitNewField = (e) => {
    if (name.length === 0) {
      console.log("name can't be empty");
      return;
    }
    if (!nameIsValid(name)) {
      console.log("invalid name");
      return;
    }
    if (!typeIsValid()) {
      console.log("invalid type");
      return;
    }
    if (typeof isList !== "boolean") {
      console.log("invalid value for isList");
      return;
    }
    const data = {
      name: name,
      type: type,
      editable: true,
      list: isList,
    };
    setFnIsRunning(true);
    const action = createField(appId, table.id, data, user);
    action
    .then(() => update())
    .catch(err => console.log(err))
    .finally(() => setOpen(false));
  };

  const handleTypeChange = (e) => {
    if (e.target.value === "none") {
      const noType = {
        name: "none"
      };
      setType(noType);
      return;
    }
    const _type = types.find((x) => x.name === e.target.value);
    setType(_type);
  };

  const handleOnChange = (e) => {
    if (nameIsValid(e.target.value)) {
      setName(e.target.value);
    }
    else {
      setIsDisabled(true);
    }
  }

  return (
    <div className={styles.newField} onClick={() => setOpen(true)}>
      <MdAdd />
      <div style={{ marginLeft: 7 }}>ADD</div>
      <Modal onClose={() => setOpen(false)} open={open}>
        {fnIsRunning ? (
          <div className={styles.form}>
            <div className={styles.formTitle}>
              New Field{" "}
              <MdClose onClick={() => setOpen(false)} className="icon" />
            </div>
            <div className={styles.formContainer}>
              Adding new field
            </div>
          </div>
        ) : (
          <div className={styles.form}>
            <div className={styles.formTitle}>
              New Field{" "}
              <MdClose onClick={() => setOpen(false)} className="icon" />
            </div>
            <div className={styles.formContainer}>
              <div className={styles.formInputTitle}>Field Name</div>
              <input
                autoFocus
                value={name}
                onChange={handleOnChange}
                placeholder="name..."
                className="input"
              />
              <div className={styles.formInputTitle}>Field Type</div>
              <select name="type" value={type.name} onChange={handleTypeChange}>
                <option value="none">Choose a type...</option>
                {types.map((t) => {
                  return (
                    <option key={t.name} value={t.name}>
                      {t.displayName}
                    </option>
                  );
                })}
              </select>
              <div className={styles.formInputTitle}>Is Field a List?</div>
              <input
                name="list"
                type="checkbox"
                checked={isList}
                onChange={(e) => setIsList(isList ? false : true)}
              />
            </div>
            <div className={styles.formContainer}>
              <button disabled={isDisabled} onClick={submitNewField}>
                Submit
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
